import React from "react";
import { AuthProviderButtons } from "../../../components/auth/AuthProviderButtons";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/Buttons";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import { SurfaceCard } from "../../../components/ui/SurfaceCard";
import { AppLink } from "../../../components/ui/link";
import { AuthPageLayout } from "./AuthPageLayout";
import type { MainAppPageProps } from "../types";

type LoginPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "oauthProviders" | "userForm"
>;

export const LoginPage: React.FC<LoginPageProps> = ({
  csrfToken,
  routes,
  oauthProviders = { google: false, apple: false },
  userForm,
}) => (
  <AuthPageLayout>
    <h1 className="mb-8 text-center font-display text-3xl font-semibold tracking-tight text-foreground">
      Welcome back
    </h1>
    <SurfaceCard className="rounded-2xl border-border p-8 shadow-lg">
      <AuthProviderButtons
        oauthProviders={oauthProviders}
        routes={routes}
        showDividerAfter={oauthProviders.google || oauthProviders.apple}
      />
      <form action={routes.login} method="post">
        <AuthenticityTokenField csrfToken={csrfToken} />
        <div className="mb-4">
          <FieldLabel htmlFor="email">Email</FieldLabel>
          <TextInput
            id="email"
            name="email"
            type="email"
            defaultValue={userForm?.email ?? ""}
            placeholder="you@example.com"
            required
          />
        </div>
        <div className="mb-2">
          <FieldLabel htmlFor="password">Password</FieldLabel>
          <TextInput
            id="password"
            name="password"
            type="password"
            placeholder="password"
            required
          />
        </div>
        <p className="mb-6 text-right text-sm">
          <AppLink to={routes.forgotPassword} variant="premium">
            Forgot password?
          </AppLink>
        </p>
        <Button
          type="submit"
          variant="premium"
          className="w-full py-3 font-medium"
        >
          Log In
        </Button>
      </form>
    </SurfaceCard>
    <p className="mt-6 text-center text-sm text-muted-foreground">
      Don&apos;t have an account?{" "}
      <AppLink to={routes.signup} variant="premium">
        Sign up
      </AppLink>
    </p>
  </AuthPageLayout>
);
